import {isInputPreparationEvent,type CodexNotification,type InputPreparationState} from '@reados/contracts';
import {turnIdentity,turnLifecycles} from './turn-lifecycle.ts';

/** Preparation is an application activity, never a native reasoning item.
 * Revisions separate multiple provider calls in one native turn; a terminal
 * preparation cannot be reopened by its delayed progress notification.
 */
export function activeInputPreparations(events:CodexNotification[]):Map<string,InputPreparationState> {
  const latest=new Map<string,InputPreparationState>();
  for(const event of events){
    if(!isInputPreparationEvent(event))continue;
    const incoming=event.params,key=turnIdentity(incoming.threadId,incoming.turnId),previous=latest.get(key);
    if(previous){
      if(incoming.revision<previous.revision)continue;
      if(incoming.revision===previous.revision){
        if(previous.status!=='preparing'&&incoming.status==='preparing')continue;
        if(incoming.sequence<=previous.sequence)continue;
      }
    }
    latest.set(key,incoming);
  }
  const turns=turnLifecycles(events),newestTurns=new Map<string,{id:string;startedAt?:number}>();
  for(const turn of turns.values()){
    const previous=newestTurns.get(turn.threadId);
    if(!previous||turn.startedAtMilliseconds===undefined&&previous.startedAt===undefined
      ||turn.startedAtMilliseconds!==undefined&&(previous.startedAt===undefined||turn.startedAtMilliseconds>previous.startedAt)){
      newestTurns.set(turn.threadId,{id:turn.id,startedAt:turn.startedAtMilliseconds});
    }
  }
  for(const [key,state] of latest){
    const turn=turns.get(key),newest=newestTurns.get(state.threadId);
    if(state.status!=='preparing'||turn?.status!=='inProgress'||newest?.id!==state.turnId)latest.delete(key);
  }
  return latest;
}
